import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable, Subject } from 'rxjs';
import { ICompteBancaire } from '../../../../app-back/src/app/shared-module/models/affaire.model';
import { ICompteBancaireSummary } from '../../../../app-back/src/app/shared-module/models/rapprochement-bancaire.model';
import { AuthSharedService } from './auth.service';
import { ICompteForUpdate } from '@core-lib/models/compte.model';
import { IDocumentDownloadOtt } from '@core-lib/models';

@Injectable({
	providedIn: 'root'
})
export class CompteBancaireService {
	get tenantKey() {
		return this.authService.currentTenantKey;
	}

	balanceEcarts: Subject<any> = new Subject<any>();
	balanceEcarts$ = this.balanceEcarts.asObservable();

	constructor(
		private http: HttpClient,
		private authService: AuthSharedService
	) {}

	get(): Observable<ICompteBancaire> {
		return this.http.get<ICompteBancaire>(`${environment.apiUrl}/t/${this.tenantKey}/compteBancaire/comptesBancaires`);
	}

	getCompteBancaireCarpaSummary(id: string): Observable<ICompteBancaireSummary> {
		return this.http.get<ICompteBancaireSummary>(
			`${environment.apiUrl}/t/${this.tenantKey}/compteBancaire/carpaSummary/${id}`
		);
	}

	getCompteBancaireBanqueSummary(id: string): Observable<ICompteBancaireSummary> {
		return this.http.get<ICompteBancaireSummary>(
			`${environment.apiUrl}/t/${this.tenantKey}/compteBancaire/banqueSummary/${id}`
		);
	}

	/*BALANCE================================================================================================*/

	calculateBalance(): Observable<any> {
		return this.http.get<any>(`${environment.apiUrl}/t/${this.tenantKey}/balance/calculateBalances`);
	}

	getPdfDownloadOtt(): Observable<IDocumentDownloadOtt> {
		return this.http.get<IDocumentDownloadOtt>(`${environment.apiUrl}/t/${this.tenantKey}/balance/pdf/ott`);
	}

	getPdfUrl(ott: string): string {
		return `${environment.apiUrl}/t/${this.tenantKey}/balance/pdf/${ott}`;
	}

	getBalanceEcarts(): Observable<boolean> {
		return this.http.get<boolean>(`${environment.apiUrl}/t/${this.tenantKey}/balance/balanceEcarts`);
	}

	/*CB compte pro ================================================================================================*/
	updateCompte(compteDto: ICompteForUpdate): Observable<any> {
		return this.http.post<any>(`${environment.apiUrl}/t/${this.tenantKey}/compte/updateCompteCoordonneesBancaires`, compteDto);
	}

	getCompteCoordonneesBancairesHistory(id: string): Observable<any> {
		return this.http.get<any>(`${environment.apiUrl}/t/${this.tenantKey}/compte/${id}/coordonneesbancaire/history`);
	}
}
